import { AppThunkDispatch, RootState } from 'store/store';
import { SMS_STORE_ACTION_TYPE } from 'store/sms/sms.type';
import { showSnackbar } from 'store/snackbar/snackbar.action';

/**
 * Action creator for updating the SMS template fields.  Currently replaces the entire payload.template.[langCode],
 * but when we understand how to serialize better, this can be adjusted.
 * */
export function updateSMSTemplateData(
  journeySMSTemplateData: Record<string, string>,
  journeySMSTemplateId: string,
  refId: string,
  language: string,
) {
  return (dispatch: AppThunkDispatch, getState: () => RootState) => {
    const smsStateItem = getState().te.sms.byRefId[refId];
    dispatch({
      type: SMS_STORE_ACTION_TYPE.UPDATE_SMS,
      payload: {
        ...smsStateItem,
        payload: {
          ...smsStateItem.payload,
          template: {
            ...smsStateItem.payload?.template,
            [language]: {
              ...smsStateItem.payload?.template?.[language],
              journeySMSTemplateId,
              journeySMSTemplateData: {
                languageCode: language,
                ...journeySMSTemplateData,
              },
            },
          },
        },
      },
    });
    dispatch(
      showSnackbar({
        content: 'Changes have been applied to the sms node',
        type: 'success',
      }),
    );
  };
}
